/**
 * Cookie domain testing utility
 * Tests if cookies are properly shared between subdomains
 */

// Test cookie sharing between subdomains
export const testCookieSharing = () => {
    const currentDomain = window.location.hostname;
    
    console.log('=== COOKIE SHARING TEST ===');
    console.log('Current domain:', currentDomain);
    console.log('All cookies:', document.cookie);
    
    // Check if we're on a subdomain
    const isSubdomain = currentDomain.includes('.');
    const baseDomain = isSubdomain ? currentDomain.split('.').slice(-2).join('.') : currentDomain;
    
    console.log('Is subdomain:', isSubdomain);
    console.log('Base domain:', baseDomain);
    
    // Test setting a cookie with different domain settings
    const testCookieName = 'test_cookie_sharing';
    const testValue = 'test_value_' + Date.now();
    
    // Test 1: Cookie for current domain only
    document.cookie = `${testCookieName}_current=${testValue}; path=/`;
    
    // Test 2: Cookie for base domain (should be shared)
    document.cookie = `${testCookieName}_base=${testValue}; domain=.${baseDomain}; path=/`;
    
    // Test 3: Cookie for parent domain
    if (isSubdomain) {
        const parentDomain = currentDomain.split('.').slice(1).join('.');
        document.cookie = `${testCookieName}_parent=${testValue}; domain=.${parentDomain}; path=/`;
    }
    
    console.log('Cookies after setting test cookies:', document.cookie);
    
    // Check which cookies are accessible
    const allCookies = document.cookie.split(';').map(c => c.trim());
    const testCookies = allCookies.filter(c => c.includes(testCookieName));
    
    console.log('Test cookies found:', testCookies);
    
    return {
        currentDomain,
        baseDomain,
        isSubdomain,
        allCookies,
        testCookies
    };
};

// Test Keycloak cookie accessibility
export const testKeycloakCookies = () => {
    console.log('=== KEYCLOAK COOKIE TEST ===');
    
    const allCookies = document.cookie.split(';').map(c => c.trim());
    const keycloakCookies = allCookies.filter(c => 
        c.includes('kc-') || 
        c.includes('keycloak') || 
        c.includes('token') || 
        c.includes('idToken')
    );
    
    console.log('All cookies:', allCookies);
    console.log('Keycloak cookies:', keycloakCookies);
    
    // Check cookie domain settings
    keycloakCookies.forEach(cookie => {
        const [name, value] = cookie.split('=');
        console.log(`Cookie: ${name}`);
        console.log(`  Value: ${value ? '[REDACTED]' : 'undefined'}`);
        
        // Try to determine domain (this is tricky from JavaScript)
        console.log(`  Domain: [Cannot determine from JS]`);
    });
    
    return {
        allCookies,
        keycloakCookies,
        hasKeycloakCookies: keycloakCookies.length > 0
    };
};

// Run all tests
export const runCookieTests = () => {
    console.log('🧪 Running cookie sharing tests...');
    
    const sharingTest = testCookieSharing();
    const keycloakTest = testKeycloakCookies();
    
    console.log('=== TEST RESULTS ===');
    console.log('Cookie sharing test:', sharingTest);
    console.log('Keycloak cookie test:', keycloakTest);
    
    return {
        sharing: sharingTest,
        keycloak: keycloakTest
    };
};
